import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function fetchTemplateList(params) {
  return request({
    url: `${v2Host}/dmaker/template/list-app`,
    method: 'get',
    params
  })
}
